module.exports = __webpack_public_path__ + "img/茂名绿色化工研究院.f35c7f3f.png";